<section class="container-fluid faq" *ngIf="faq?.length">
    <div class="container">
        <div class="row">
            <div class="col-12 col-lg-3 col-xl-2">
                <h2>FAQ</h2>
            </div>
            <div class="col-12 col-lg-9 col-xl-10">
                <ngb-accordion id="acc" #acc="ngbAccordion" [closeOthers]="true">
                    <ngb-panel [id]="i" *ngFor="let item of faq; let i = index">
                        <ng-template ngbPanelTitle>
              <span>
                <span>{{item.title | translate}}</span>
              </span>
                        </ng-template>
                        <ng-template ngbPanelContent>
              <span class="faq-item-text">
                  <p *ngFor="let text of item.texts">
                      {{text | translate}}
                  </p>
                   <ol *ngIf="item?.list">
                  <li *ngFor="let li of item.list">
                      {{li | translate}}
                  </li>
                </ol>
              </span>
                        </ng-template>
                    </ngb-panel>
                </ngb-accordion>

            </div>
        </div>
    </div>
</section>

